{
  "ResourceModal": {
    "title": "Generate resource PDF",
    "managerTitle": "Available Fields",
    "Instagram": "Instagram",
    "Twitter": "Twitter",
    "Behance": "Behance",
    "Youtube": "Youtube",
    "Vimeo": "Vimeo",
    "Website": "Website",
    "Email": "Email",
    "Phone number": "Phone number",
    "Location": "Location",
    "Rate": "Rate",
    "Tags": "Tags",
    "Organization": "Organization",
    "Agent": "Agent",
    "Groups": "Groups",
    "QR Code": "QR Code",
    "Options": "Options"
  }
}
